import { useSuspenseQuery } from '~/services'

export function useBillingReadonly(workspaceId: string) {
  const { data } = useSuspenseQuery('workspaces_/$workspaceId_/billing/readonly', { workspaceId })
  return { billingReadonly: data }
}
